/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';

const messages = defineMessages({
    pageTitle: {
        id: 'portal.notFoundPage.pageTitle',
        defaultMessage: 'LUIS: Not Found'
    },
    pageHeader: {
        id: 'portal.notFoundPage.pageHeader',
        defaultMessage: "We're sorry! The page you are looking for can not be found."
    },
    pageSubHeader: {
        id: 'portal.notFoundPage.pageSubHeader',
        defaultMessage: 'That means we either broke something or the page you requested does not exist.'
    }
});

const { styleComponent } = getStylist('NotFoundPage');
const CenteredText = styleComponent<LuisTextProps>(LuisText)('CenteredText', theme => ({
    textAlign: 'center',
    marginBottom: theme.textMargin
}));

/**
 * Renders a simple not found page.
 */
export const NotFoundPage = () => {
    const { localize } = useLocalization();

    return (
        <Page pageName="NotFoundPage" size="container" title={localize(messages.pageTitle)}>
            <CenteredText variant="mega" as="h1">
                404
            </CenteredText>

            <CenteredText variant="xxLargePlus" as="h2">
                {localize(messages.pageHeader)}
            </CenteredText>

            <CenteredText variant="xLargePlus" as="h3">
                {localize(messages.pageSubHeader)}
            </CenteredText>
        </Page>
    );
};
